import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ComodoreIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.3 7C3.08593 7 2.94074 6.78222 3.02308 6.58462L5.72308 1.18462C5.76966 1.07282 5.87889 1 6 1H10C10.1136 1 10.2175 1.0642 10.2683 1.16584L12.9683 6.56584C13.0681 6.76531 12.923 7 12.7 7H11V8H12.7C12.8657 8 13 8.13431 13 8.3V9.92918C13 9.97575 13.0108 10.0217 13.0317 10.0633L14.9683 13.9367C14.9892 13.9783 15 14.0242 15 14.0708V14.7C15 14.8657 14.8657 15 14.7 15H1.3C1.13431 15 1 14.8657 1 14.7V14.0708C1 14.0242 1.01084 13.9783 1.03167 13.9367L2.96833 10.0633C2.98916 10.0217 3 9.97575 3 9.92918V8.3C3 8.13431 3.13431 8 3.3 8H5V7H3.3ZM4.5 9C4.22386 9 4 9.22386 4 9.5V10C4 10.2761 4.22386 10.5 4.5 10.5H11.5C11.7761 10.5 12 10.2761 12 10V9.5C12 9.22386 11.7761 9 11.5 9H4.5ZM3.14472 13.2106L3.94472 11.6106C3.9786 11.5428 4.04785 11.5 4.12361 11.5H11.8764C11.9521 11.5 12.0214 11.5428 12.0553 11.6106L12.8553 13.2106C12.9218 13.3435 12.8251 13.5 12.6764 13.5H3.32361C3.17493 13.5 3.07823 13.3435 3.14472 13.2106ZM7.25 2.5C6.69772 2.5 6.25 2.94772 6.25 3.5V5C6.25 5.55228 6.69772 6 7.25 6H8.75C9.30228 6 9.75 5.55228 9.75 5V3.5C9.75 2.94772 9.30229 2.5 8.75 2.5H7.25Z"
		></path>
	</svg>
))
